import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import Skeleton from 'react-loading-skeleton';
import sessionEngagementActivityAnalyticService from '../../../services/session-engagement-activity-analytics.service';

const PeakUsageDistribution = () => {
  const [hourlySessions, setHourlySessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPeakUsageData = async () => {
      setError(false);
      setLoading(true);
      try {
        const data =
          await sessionEngagementActivityAnalyticService.getPeakUsageDistribution();
        if (data.hourly_sessions.length == 0) {
          setHourlySessions([]);
        } else {
          const sessionsMap = Object.fromEntries(
            data.hourly_sessions.map(({ hour, session_count }) => [
              hour,
              session_count,
            ]),
          );

          const fullHourLabels = Array.from({ length: 24 }, (_, i) =>
            i.toString().padStart(2, '0'),
          );
          const normalizedSessions = fullHourLabels.map(
            (hour) => sessionsMap[hour] || 0,
          );

          setHourlySessions({
            labels: fullHourLabels,
            data: normalizedSessions,
          });
        }
      } catch (err) {
        console.error('Error fetching peak usage times:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPeakUsageData();
  }, []);

  if (loading) {
    return (
      <div className="mb-3">
        <Skeleton
          height={20}
          width={220}
          baseColor="#dee2e6"
          highlightColor="#e9ecef"
        />
        <Skeleton
          height={14}
          width={160}
          baseColor="#dee2e6"
          highlightColor="#e9ecef"
          style={{ marginTop: 8 }}
        />
        <Skeleton height={280} baseColor="#dee2e6" highlightColor="#e9ecef" />
      </div>
    );
  }
  if (error)
    return <div className="text-danger">Failed to load peak usage data.</div>;

  if (hourlySessions.length === 0) {
    return (
      <div className="text-muted text-center fw-semibold">
        No data available for peak usage times.
      </div>
    );
  }

  const options = {
    chart: {
      type: 'bar',
      height: 350,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '80%',
      },
    },
    colors: ['#10b981'],
    dataLabels: { enabled: false },
    xaxis: {
      categories: hourlySessions.labels,
      labels: {
        style: { colors: '#6b7280' },
        rotate: -45,
      },
    },
    yaxis: {
      labels: { style: { colors: '#6b7280' } },
    },
    tooltip: {
      y: { formatter: (val) => `${val} sessions` },
    },
    grid: {
      borderColor: '#e5e7eb',
      strokeDashArray: 4,
    },
  };

  const series = [
    {
      name: 'Sessions',
      data: hourlySessions.data,
    },
  ];

  return <Chart options={options} series={series} type="bar" height={350} />;
};

export default PeakUsageDistribution;
